import { render, staticRenderFns } from "./HelloMessage.vue?vue&type=template&id=534efc54&scoped=true&"
import script from "./HelloMessage.vue?vue&type=script&lang=js&"
export * from "./HelloMessage.vue?vue&type=script&lang=js&"
import style0 from "./HelloMessage.vue?vue&type=style&index=0&id=534efc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534efc54",
  null
  
)

export default component.exports